import { IItem } from '../interfaces/organizations';
import { IReviewUser } from '../interfaces/reviews';

export const loadUseDesk = (userInfo: IReviewUser, organizationsList: IItem[]) => {
  if (userInfo?.companyId) {
    const organizationName = organizationsList.find((el) => +el.id === +userInfo?.companyId)?.name;
    const script = document.createElement('script');
    script.src = 'https://lib.usedesk.ru/secure.usedesk.ru/widget_154534_26075.js';
    script.async = true;
    script.onload = () => {
      // @ts-ignore
      window.usedeskMessenger.userIdentify({ name: `${userInfo?.authorName} ${organizationName}` });
    };
    document.body.appendChild(script);
  }
};
